// extracted by mini-css-extract-plugin
export default {"wrapper":"C6zXm2fX1gQx9TbXbRiS","select":"OtoBwZiLZoohwAbPqZL2","profile":"nYSfWHTWMREdeASEZr5E"};